import { neutral7 } from 'apollo-react/colors';
import IconButton from 'apollo-react/components/IconButton';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import TextField from 'apollo-react/components/TextField';
import Tooltip from 'apollo-react/components/Tooltip';
import Typography from 'apollo-react/components/Typography';
import ChevronDown from 'apollo-react-icons/ChevronDown';
import ChevronRight from 'apollo-react-icons/ChevronRight';
import Trash from 'apollo-react-icons/Trash';
import React, { useState } from 'react';

import { SS_CONTROL_TYPE } from '../../../../constants/form-manager.constants';

const fieldStyles = {
  style: {
    margin: 0,
  },
};

export const ActionCell = ({ row }) => {
  const { id, editRow, source, controlType } = row;
  return (
    (source === 'property' || controlType === SS_CONTROL_TYPE.MODAL) && (
      <IconButton onClick={() => editRow(id, null, false, true)}>
        <Trash />
      </IconButton>
    )
  );
};

export const EditableCellOpenEntity = ({ row, column: { accessor: key } }) => {
  const [codeIcon, setCodeIcon] = useState(true);
  const { source } = row;

  const tooltipLable = row.updateTo.split('.')[1];

  return (
    <Tooltip
      extraLabels={[{ title: '' }, { subtitle: tooltipLable }]}
      placement="bottom"
      variant="light"
    >
      <TextField
        size="small"
        fullWidth
        value={row[key]}
        disabled={source !== 'property'}
        icon={
          source === 'property' ? (
            codeIcon ? (
              <ChevronRight
                fontSize="extraSmall"
                onClick={() => {
                  row.handleToggleRow(row.id, key);
                  setCodeIcon(false);
                }}
              />
            ) : (
              <ChevronDown
                fontSize="extraSmall"
                onClick={() => {
                  row.handleToggleRow(row.id, key);
                  setCodeIcon(true);
                }}
              />
            )
          ) : null
        }
        {...fieldStyles}
        inputProps={{
          style: { borderColor: codeIcon ? '' : 'blue' },
        }}
      />
    </Tooltip>
  );
};

export const DataSourceValuesList = ({ row }) => {
  const { fieldList, updateFrom, source } = row;

  const [value, setValue] = useState('');

  React.useEffect(() => {
    setValue(updateFrom);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldList]);

  const onChangeHandler = (event) => {
    setValue(event.target.value);
    onChangeFunction(event.target.value);
  };

  const getTranslateFromList = (value) => {
    const object = fieldList.filter((item) => item.value === value)[0];
    return object.label;
  };

  const onChangeFunction = (value) => {
    const newValue = {
      source: row.source,
      translatedUpdateFrom: getTranslateFromList(value),
      updateFrom: value,
      updateToType: row.updateToType,
      updateTo: row.updateTo,
      translatedUpdateTo: row.translatedUpdateTo,
    };
    row.editRow(row.id, newValue, true);
  };

  return (
    <div style={{ width: 'auto' }}>
      <Select
        size="small"
        fullWidth
        value={fieldList.length === 0 ? '' : value}
        onChange={onChangeHandler}
        disabled={source !== 'property'}
        canDeselect={false}
        {...fieldStyles}
      >
        {fieldList.map(({ value, label }) => {
          return (
            <MenuItem key={`${row.id} + ${value}`} value={value}>
              {label ? `${label} (${value})` : value}
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
};

export const ReadOnlyColumn = ({ row, column: { accessor: key } }) => {
  const providedText = () => {
    if (key === 'translatedUpdateTo') {
      return `${row[key]} (${row.updateTo})`;
    }
    if (key === 'translatedUpdateFrom') {
      return `${row[key]} (${row.updateFrom})`;
    }

    return '';
  };
  return (
    <Typography variant="body2" style={{ color: neutral7 }}>
      {providedText()}
    </Typography>
  );
};

export const EntityColumnsList = ({ row, column: { accessor } }) => {
  const {
    targetEntityColumnsList,
    sourceEntityColumnsList,
    updateTo,
    updateFrom,
    targetEntityName,
  } = row;

  const fieldList =
    accessor === 'translatedUpdateTo' ? targetEntityColumnsList : sourceEntityColumnsList;

  const [value, setValue] = useState(() =>
    accessor === 'translatedUpdateTo' ? updateTo.split('.')[1] : updateFrom
  );

  const getTranslatedValue = (list, selectedValue) =>
    list.find((item) => item.value === selectedValue).label;

  const onChangeHandler = ({ target: { value: eventValue } }) => {
    setValue(eventValue);

    let newValue;

    if (accessor === 'translatedUpdateTo') {
      newValue = {
        updateFrom: row.updateFrom,
        translatedUpdateFrom: row.translatedUpdateFrom,
        updateTo: `${targetEntityName}.${eventValue}`,
        translatedUpdateTo: getTranslatedValue(targetEntityColumnsList, eventValue),
      };
    } else {
      newValue = {
        updateFrom: eventValue,
        translatedUpdateFrom: getTranslatedValue(sourceEntityColumnsList, eventValue),
        updateTo: row.updateTo,
        translatedUpdateTo: row.translatedUpdateTo,
      };
    }

    row.editRow(row.id, newValue, true);
  };

  return (
    <div style={{ width: 'auto' }}>
      <Select
        size="small"
        fullWidth
        value={value}
        onChange={onChangeHandler}
        canDeselect={false}
        {...fieldStyles}
      >
        {fieldList.map(({ value, label }) => (
          <MenuItem key={`${row.id} + ${value}`} value={value}>
            {label ? `${label} (${value})` : value}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};
